class MadesaInspiracaoSlideshow extends HTMLElement {
  constructor() {
    super();

    this.panels = [];
    this.slideshows = [];
    this.thumbs = [];
    this.paginationItems = [];
    this.activePanelIndex = 0;
    this.canScrollActiveThumb = false;

    this.handleThumbClick = this.handleThumbClick.bind(this);
    this.handlePaginationClick = this.handlePaginationClick.bind(this);
    this.handleSlideshowSelect = this.handleSlideshowSelect.bind(this);
  }

  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('.madesa-inspiracao__panel[data-panel-index]'));
    this.slideshows = this.panels
      .map((panel) => panel.querySelector('slideshow-component'))
      .filter((element) => element instanceof HTMLElement);
    this.thumbs = Array.from(this.querySelectorAll('[data-thumb-index]'));
    this.paginationItems = Array.from(this.querySelectorAll('[data-pagination-index]'));

    if (this.thumbs.length === 0 || this.panels.length === 0) return;

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', this.handleThumbClick);
    });

    this.paginationItems.forEach((item) => {
      item.addEventListener('click', this.handlePaginationClick);
    });

    this.slideshows.forEach((slideshow) => {
      slideshow.addEventListener('slideshow:select', this.handleSlideshowSelect);
    });

    this.setActivePanel(0);
    this.canScrollActiveThumb = true;
  }

  disconnectedCallback() {
    this.thumbs.forEach((thumb) => {
      thumb.removeEventListener('click', this.handleThumbClick);
    });

    this.paginationItems.forEach((item) => {
      item.removeEventListener('click', this.handlePaginationClick);
    });

    this.slideshows.forEach((slideshow) => {
      slideshow.removeEventListener('slideshow:select', this.handleSlideshowSelect);
    });
  }

  handleThumbClick(event) {
    const thumb = event.currentTarget;
    const index = Number(thumb?.dataset.thumbIndex);

    if (Number.isNaN(index)) return;
    this.setActivePanel(index);
  }

  handlePaginationClick(event) {
    const item = event.currentTarget;
    const panelIndex = Number(item?.dataset.panelIndex);
    const index = Number(item?.dataset.paginationIndex);
    const panel = this.panels[panelIndex];
    const slideshow = panel?.querySelector('slideshow-component');

    if (
      Number.isNaN(panelIndex)
      || Number.isNaN(index)
      || !(slideshow instanceof HTMLElement)
      || typeof slideshow.select !== 'function'
    ) return;

    this.setActivePanel(panelIndex);
    slideshow.select(index);
  }

  handleSlideshowSelect(event) {
    const slideshow = event.currentTarget;
    const panel = slideshow?.closest('[data-panel-index]');
    const panelIndex = Number(panel?.dataset.panelIndex);

    if (Number.isNaN(panelIndex)) return;
    if (!event.detail || typeof event.detail.index !== 'number') return;

    this.setPanelPaginationState(panelIndex, event.detail.index);
  }

  setActivePanel(index) {
    this.activePanelIndex = index;

    this.thumbs.forEach((thumb, thumbIndex) => {
      const isActive = thumbIndex === this.activePanelIndex;

      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-selected', String(isActive));
      thumb.setAttribute('tabindex', isActive ? '0' : '-1');

      if (isActive && this.canScrollActiveThumb) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });

    this.panels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === this.activePanelIndex;
      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    this.setPanelPaginationState(this.activePanelIndex);
  }

  setPanelPaginationState(panelIndex, selectedIndex = 0) {
    this.paginationItems.forEach((item) => {
      const itemPanelIndex = Number(item.dataset.panelIndex);
      const itemSlideIndex = Number(item.dataset.paginationIndex);
      const isSelectedPanel = itemPanelIndex === panelIndex;
      const isActive = isSelectedPanel && itemSlideIndex === selectedIndex;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });
  }
}

if (!customElements.get('madesa-inspiracao-slideshow')) {
  customElements.define('madesa-inspiracao-slideshow', MadesaInspiracaoSlideshow);
}
